export enum mediaType {
  NONE = 'NONE',
  PLAY_IN = 'PLAY_IN',
  SCREENSHARE = 'SCREENSHARE',
  WEBCAM = 'WEBCAM',
  SLIDES = 'SLIDES',
  SPOTLIGHT = 'SPOTLIGHT',
  EVENT_STREAM = 'EVENT_STREAM'
}

export type MediaType = keyof typeof mediaType
